import { PaxPrice, SuiteNumber } from "@ssc-booking/api-contracts"
import * as O from "fp-ts/Option"
import { paxRow, ReceiptSection } from "../types"
import { guestLabel } from "./utils"
import { cruiseLabel } from "./utils-components"

export const cruiseToReceiptSection =
    (suiteName: string, selectedSuiteNumber?: SuiteNumber) =>
    (paxPrice: PaxPrice): ReceiptSection => ({
        label: cruiseLabel(suiteName, selectedSuiteNumber),
        key: "cruise",
        isPromotional: false,
        totalAmount: O.some(paxPrice.details.cruise.price),
        rows: [
            paxRow({
                label: guestLabel(paxPrice.number),
                isPromotional: false,
                amount: O.some(paxPrice.details.cruise.price),
            }),
        ],
    })
